import { App, useCurrentApp, useIntl } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../../core/types';

export const useProductLabel = (
  { availability, product_label }: GenericVehicleDetails,
  partnerDiscount?: number
) => {
  const { formatMessage } = useIntl();
  const isB2BApp = useCurrentApp() === App?.B2B;

  let label =
    (!availability && formatMessage('plp.outOfStock')) ||
    (!partnerDiscount && product_label?.label);

  if (
    typeof label === 'string' &&
    label.toLowerCase().includes('mai10') &&
    isB2BApp
  ) {
    label = '10 % Rabatt';
  }

  return label;
};
